export function ec2LaunchInstanceUserKeyValidator(value: string) {
  const m = value.match(/^[a-zA-Z][a-zA-Z0-9-]{2,}[a-zA-Z0-9]$/);
  if (m) {
    return undefined;
  }

  return 'Invalid user key. It must be at least 4 characters long and start with a letter. It can contain letters, numbers, and hyphens.';
}
